import React, {PropTypes as T} from 'react';
import cn from 'classnames';

export default class ModalHeader extends React.Component {
  static propTypes = {
    dataComponent: T.string,
    children:  T.node,
    isWarning: T.bool,
    isError:   T.bool,
    isSuccess: T.bool,
    isInfo:    T.bool,
    isLoading:    T.bool
  };

  render () {
    const classNames = cn({
      'modal__header--error': this.props.isError,
      'modal__header--success': this.props.isSuccess,
      'modal__header--warning': this.props.isWarning,
      'modal__header--info': this.props.isInfo,
      'modal__header--loading': this.props.isLoading,
      'modal__header': true
    });
    const dataComponent = this.props.dataComponent || 'modal-header';

    return (
      <div className={classNames} data-component={dataComponent}>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/common/modal/header.js